module.exports = __webpack_public_path__ + "9e8fd3.png";